module.exports = __webpack_public_path__ + "img/t1-5.3e905086.png";